import { useState, useEffect, useMemo } from 'react'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import _pick from 'lodash/pick'
import _isArray from 'lodash/isArray'
import HeaderFilterButton from 'app/SeFriendly/SeFriendlyProviderSearch/HeaderFilterButton'
import { ProviderFilterTypes } from 'dataSource/ProviderSearch'
import styles from './index.module.scss'
import { filterTitle } from 'constants/common'
const MultiselectDropdown = dynamic(() => import('common/MultiselectDropdown'))

type AreaOfConcernFilterProps = {
  onFilterSelect: (selectedFilter: Record<string, unknown>) => void
  groupedFilters: GroupedProviderFilter
  containerClassName?: string
}

const AreaOfConcernFilter: React.FC<AreaOfConcernFilterProps> = ({
  onFilterSelect,
  groupedFilters,
  containerClassName = '',
}) => {
  const router = useRouter()
  const { query } = router
  const [showDropdown, setShowDropdown] = useState<boolean>(false)
  const [appliedAreasOfConcern, setAppliedAreasOfConcerns] = useState<string[]>(
    []
  )
  const allAreasOfConcern = groupedFilters[ProviderFilterTypes.AREA_OF_CONCERN]

  useEffect(() => {
    const areasIdsInQuery = _pick(query, 'areaOfConcern[]')['areaOfConcern[]']

    if (!areasIdsInQuery && !appliedAreasOfConcern.length) {
      return
    }

    if (!areasIdsInQuery) {
      //When Clear button in pill was clicked
      setAppliedAreasOfConcerns([])
      return
    }

    if (!_isArray(areasIdsInQuery)) {
      //In case only one Area of Concern was Selected
      setAppliedAreasOfConcerns([areasIdsInQuery as string])
    } else {
      setAppliedAreasOfConcerns([...(areasIdsInQuery as string[])])
    }
  }, [query])

  const onApply = (selectedAreas: string[]) => {
    onFilterSelect({ areaOfConcern: selectedAreas })
    setAppliedAreasOfConcerns(selectedAreas)
  }

  const areaOfConcernStringValue = useMemo(() => {
    return appliedAreasOfConcern.reduce((concat, areaOfConcernId, index) => {
      const areaOfConcernFilter = allAreasOfConcern.find(
        (areaOfConcern) => areaOfConcern.id === areaOfConcernId
      )

      if (areaOfConcernFilter) {
        if (index === 0) {
          return areaOfConcernFilter.value
        }

        return `${concat}, ${areaOfConcernFilter.value}`
      }

      return concat
    }, '')
  }, [appliedAreasOfConcern])

  return (
    <HeaderFilterButton
      title={filterTitle.SPECIALTY}
      showDropdown={showDropdown}
      setShowDropdown={setShowDropdown}
      filterType={ProviderFilterTypes.AREA_OF_CONCERN}
      text={areaOfConcernStringValue}
      placeHolder="I want help for..."
      mobilePlaceHolder="Help for"
      buttonClassName={[styles.helpfor_filter_button, 'form-search speciality']}
      containerClassName={containerClassName}
      type="specialty"
    >
      <MultiselectDropdown
        filterTypeText="specialties"
        filterList={allAreasOfConcern}
        appliedFilters={appliedAreasOfConcern}
        onApply={onApply}
        containerClassName="top-6 mt-5 seFriendly-filter-new-multiSelect-container"
      />
    </HeaderFilterButton>
  )
}

export default AreaOfConcernFilter
